import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import textCss from '../../../../../components/form/elements/text.module.css';
import css from '../../index.module.css';

interface Props {
  title?: string;
  summ?: number | null;
  item?: any;
}

export default function TableHeadings({
  title = '',
  summ = null,
  item,
}: Props) {
  const { t } = useTranslation();
  const formMethods = useFormContext();
  const [value, setHeadingValue] = useState(summ);
  const { register, control, setValue, getValues } = formMethods;

  const watchValues = useWatch({
    name: item.calculable,
    disabled: !item.calculable,
  });
  useEffect(() => {
    function setSum(sum: number) {
      sum = parseFloat(sum.toFixed(2));
      if (getValues(item.name) !== sum) {
        if (sum !== 0) {
          setValue(item.name, sum);
          setHeadingValue(sum);
        } else {
          setValue(item.name, 0);
          setHeadingValue(0);
        }
      }
    }

    if (watchValues && watchValues.length) {
      const sum = watchValues.reduce((accumulator: any, currentValue: any) => {
        return parseFloat((accumulator + Number(currentValue)).toFixed(2));
      }, 0);
      setSum(sum);
    } else {
      if (!Object.values(watchValues).length) {
        if (getValues(item.name) !== 0) {
          setHeadingValue(0);
        }
      }
    }
  }, [item.name, setValue, getValues, watchValues]);

  return (
    <div className={css['table-head']}>
      <div className={css['table-data-sub-budget']}>{title}</div>
      <div className={css['table-data']}>
        {value ? (
          <>
            {value}
            <Controller
              name={item.name}
              control={control}
              render={({ field }) => {
                return (
                  <div className={textCss['input-container']}>
                    <input
                      type="hidden"
                      name={item.name}
                      data-name={item.name + '_input'}
                      className={textCss['input']}
                      min="0"
                      step=".01"
                      {...register(item.name)}
                      {...field}
                      value={value}
                      disabled={false}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                      }}
                    />
                  </div>
                );
              }}
            />
          </>
        ) : (
          t('pages.finance.budget.heading.total')
        )}
      </div>
      <div className={css['table-data']}></div>
    </div>
  );
}
